module.exports = __webpack_public_path__ + "static/media/menu-top-banner.fc19b71c.png";